import { InputSearch, useMergeRefs, useUpdateEffect } from '@web/walter-ui-kit'
import React, { MutableRefObject, RefObject, useCallback, useEffect, useRef, useState } from 'react'

import styles from './style.module.css'
import { useSearchSlotContext } from '~contexts/SearchContext'

interface Props {
    placeholder: string
    wrapperRef: RefObject<HTMLDivElement>
    searchInputRef: MutableRefObject<HTMLInputElement | null>
    isDisabled?: boolean
}

function SearchInput(props: Props) {
    const inputRef = useRef<HTMLInputElement | null>(null)
    const [searchInput, setSearchInput] = useState('')
    const { setSearchString, startSearching, stopSearching, isSearching } = useSearchSlotContext()
    const mergedRef = useMergeRefs(inputRef, props.searchInputRef)

    useUpdateEffect(() => {
        if (!isSearching) {
            setSearchInput('')
            inputRef.current?.blur()
        }
    }, [isSearching, setSearchInput])

    const onChangeInput = useCallback(
        (value: string) => {
            setSearchInput(value)
            setSearchString(value)
        },
        [setSearchInput, setSearchString]
    )

    useEffect(() => {
        if (!isSearching) {
            return
        }

        const handleKeyDown = (e: KeyboardEvent) => {
            if (e.key === 'Escape') {
                stopSearching()
                inputRef.current?.blur()
            }
        }

        window.addEventListener('keydown', handleKeyDown)
        return () => {
            window.removeEventListener('keydown', handleKeyDown)
        }
    }, [isSearching, stopSearching])

    return (
        <div data-pointer="header_search" className={styles.inputContainer} ref={props.wrapperRef}>
            <InputSearch
                fullWidth
                isDisabled={props.isDisabled}
                value={searchInput}
                inputRef={mergedRef}
                onFocus={startSearching}
                onChange={onChangeInput}
                dataPointer="input_search"
                placeholder={props.placeholder}
            />
        </div>
    )
}

export default SearchInput
